import * as React from 'react';
import { Dimmer, Header, Loader } from 'semantic-ui-react';
import enhance from './enhancer';

function StripeRefreshCallback(props) {
  return (
    <div className="app_stripe_refresh flex">
      <Dimmer page active={props.isLoading}>
        <Loader active={props.isLoading} />
      </Dimmer>
      {!props.isLoading && (
        <div className="w__contents flex">
          <Header as="h1">口座登録を再開します</Header>
          <p>口座登録の画面を再度表示します。しばらくお待ちください。</p>
        </div>
      )}
    </div>
  );
}

export default enhance((props) => <StripeRefreshCallback {...props} />);
